const TagHeading = ({ text, className = "" }) => {
    return (
        <p className={`text-base font-semibold tracking-widest uppercase mb-3 ${className}`}>{text}</p>
    );
};

export default TagHeading;
